import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { AdControlDropdownMenu, DismissalButton, ReasonsButton } from '@atlassian/ad-control-toolkit';
import { UNDO_DISMISSAL_FAILED, UNDO_DISMISSAL_STARTED, UNDO_DISMISSAL_SUCCEEDED } from '../../common/constants';
import { useAppRecommendationsProvider } from '../../controllers';
import { useDismissal } from '../../controllers/use-dismissal';
import { messages } from '../messages';
import { ReasonsModalBody } from '../reasons-modal-body';
const AppRecommendationsAdControl = ({
  productId,
  reasons,
  name,
  enableUndo = false,
  ...dropDownMenuProps
}) => {
  const {
    contextResolver,
    endpoint,
    onEvents
  } = useAppRecommendationsProvider();
  const {
    dismissRecommendation,
    undoDismissal
  } = useDismissal({
    endpoint,
    contextResolver
  });
  const handleOnDismiss = React.useCallback(() => {
    dismissRecommendation(productId);
    // To ensure the user experience is smooth, we remain the current behaviour and don't need to wait for the promise to resolve
    return Promise.resolve();
  }, [dismissRecommendation, productId]);
  const handleOnUndoDismissal = React.useCallback(async () => {
    onEvents === null || onEvents === void 0 ? void 0 : onEvents({
      type: UNDO_DISMISSAL_STARTED,
      itemId: productId
    });
    try {
      await undoDismissal(productId);
      onEvents === null || onEvents === void 0 ? void 0 : onEvents({
        type: UNDO_DISMISSAL_SUCCEEDED,
        itemId: productId
      });
    } catch (e) {
      onEvents === null || onEvents === void 0 ? void 0 : onEvents({
        type: UNDO_DISMISSAL_FAILED,
        itemId: productId
      });
    }
  }, [onEvents, productId, undoDismissal]);
  return /*#__PURE__*/React.createElement(AdControlDropdownMenu, _extends({
    itemId: productId
  }, dropDownMenuProps), props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DismissalButton, _extends({}, props, {
    onClick: handleOnDismiss,
    flagProps: {
      actions: [enableUndo && {
        content: /*#__PURE__*/React.createElement(FormattedMessage, messages.undo),
        onClick: (e, dismissFlag) => {
          handleOnUndoDismissal();
          dismissFlag();
        }
      }].filter(action => !!action)
    }
  })), reasons !== undefined && reasons !== null && reasons.length !== 0 ? /*#__PURE__*/React.createElement(ReasonsButton, _extends({}, props, {
    modalProps: {
      body: /*#__PURE__*/React.createElement(ReasonsModalBody, {
        productId: productId,
        name: name,
        reasons: reasons
      })
    }
  })) : null));
};
export default AppRecommendationsAdControl;